import { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { useMsal } from '@azure/msal-react';
import { useQuery } from '@tanstack/react-query';
import { request } from '../../services/request';
import { Root } from '../../types/dashboard';
import { customURLs, formatAddress, getToken, isTokenExpired } from '../../tools/utils';
import { RootExam } from '../../types/exams';
import useIsMobile from '../../hooks/Helper/useIsMobile';
import { useTranslation } from 'react-i18next';
import { useGlobalContext } from '../../hooks/Helper/GlobalContext';
import { NotificationBanner } from '../../components/NotificationBanner/NotificationBanner';
import { ProfileCard } from '../../components/Dashboard/ProfileCard';
import { MyCertificationCard } from '../../components/Cards/myCertificationCard';
import { DashboardSkeleton } from '../../components/Skeliton/DashboardSkeleton';
import '../../sass/base/Dashboard.scss';
import { environment } from '../../services/envoirnment';  
import { AppDispatch, RootState } from '../../redux/store';
import { useDispatch, useSelector } from 'react-redux';
import { getUser } from '../../redux/slices/contactSlice';
import { useNavigate } from 'react-router-dom';

export const Dashboard = ({ headerMarginTop }: { headerMarginTop: number }) => {
    const { CandidateAccessControl, CandidateBannerMessage, PhotoBannerMessage, CandidateBannerColor, Color, ProviderAccessControl, CandidateId } = useGlobalContext();
    const { REACT_APP_Exam_Hub_URL, REACT_APP_DEMO_Exam_URL } = process.env;
    const { t } = useTranslation();
    const isMobile = useIsMobile();
    const { accounts } = useMsal();
    const isAuthenticated = accounts.length > 0;
    const { contact, loading, error } = useSelector((state: RootState) => state.contact);
    const [isExpired, setIsExpired] = useState(false);
    const token = getToken();
    const token_expiry = '';
   const dispatch = useDispatch<AppDispatch>();
    const navigate = useNavigate();
    useEffect(() => {
       if(isAuthenticated && contact===null && !loading && !error){
        dispatch(getUser());
       }
    },[isAuthenticated]);
      useEffect(() => {
        if (contact && contact.IsProfileCompleted === false) {
            navigate('/account/?incomplete');
        }
    }, [contact]);
    useEffect(() => {
        const checkTokenExpiration = () => {
            const isExpired = isTokenExpired(token_expiry);
            setIsExpired(isExpired);
        };
        const timer = setInterval(checkTokenExpiration, 5000); // Adjust the interval as needed
        return () => {
            clearInterval(timer); // Clean up the timer when the component unmounts
        };
    }, [token_expiry]);
    const exams = useQuery<RootExam, Error>(['exams'], async () => {
        const jsonResponse = await request({ endpoint: 'Exams' });
        if (!jsonResponse.success) {
            throw new Error(jsonResponse.data.Message || 'Something went wrong');
        }
        return jsonResponse;
    }, { refetchOnWindowFocus: false, });
    const data = (contact || {}) as unknown as Root['data'];
    const objExams = (exams.data?.data || {}) as unknown as RootExam['data'];
    // const dataCerts = (certs.data?.data || []) as unknown as Root['data']['Certificates'];
    const address = (data?.Addresses?.length || 0) > 0 ? formatAddress(data.Addresses[0]) : null;
    const [profilePictureLoading, setprofilePictureLoading] = useState(true);
    const handleImageLoaded = () => { setprofilePictureLoading(false); };
    const handleIsExpiredClick = (event: any) => {
        if (isExpired) {
            event.preventDefault(); // Prevent the default action of the link
            window.location.reload(); // Token has expired, refresh the page
        }
    };

    //const userProfileData = userProfilePicture.data;
    useEffect(() => {
        const checkTokenExpiration = () => {
            const isExpired = isTokenExpired(token_expiry);
            setIsExpired(isExpired);
        };
        const timer = setInterval(checkTokenExpiration, 5000); // Adjust the interval as needed
        return () => {
            clearInterval(timer); // Clean up the timer when the component unmounts
        };
    }, [token_expiry]);
    const photoBannerVisible = contact !== null && !error && !contact.ContactPhotoRequest && !contact.myCCOPicture;
    const IsPendingCert = contact !== null && !error && contact.IsPendingCert;

    const candidateBannerVisible = CandidateAccessControl ? (CandidateAccessControl !== 'Normal' && CandidateAccessControl !== 'Watched') : false;

    const isIpad = (window.innerWidth >= 768 && window.innerWidth <= 1024);
    const getMarginTop = () => {

        return "0px";
    };


    useEffect(() => {
        const script = document.createElement("script");
        script.src = "//servedby.revive-adserver.net/asyncjs.php"; // <<< your correct script
        script.async = true;
        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        };
    }, []);

    useEffect(() => {
        const style = document.createElement('style');
        style.innerHTML = `
    .notification-banner,
    .notification-banner .cco_row,
    .notification-banner .cco_col,
    .notification-banner .cco_text {
      margin: 0 !important;
      padding: 12 !important;
      border: none !important;
      text-align: center
    }
  `;
        document.head.appendChild(style);

        return () => {
            if (document.head.contains(style)) {
                document.head.removeChild(style);
            }
        };
    }, []);


    useLayoutEffect(() => {
        if (typeof window === "undefined") return;

        const recalc = () => {
            const sidebar = document.getElementById("ccoSidebar") as HTMLElement | null;
            if (!sidebar) return;

            const visibleCount = [
                photoBannerVisible,
                candidateBannerVisible,
                IsPendingCert,
            ].filter(Boolean).length;

            sidebar.style.paddingTop =
                visibleCount > 0 ? `${visibleCount * 90}px` : "";
        };

        recalc();
        window.addEventListener("resize", recalc);

        return () => {
            window.removeEventListener("resize", recalc);
            const sidebar = document.getElementById("ccoSidebar") as HTMLElement | null;
            if (sidebar) sidebar.style.paddingTop = "";
        };
    }, [photoBannerVisible, candidateBannerVisible, IsPendingCert]);



    return (
        <div id="main-content" style={{ marginTop: `${headerMarginTop}px` }}   >
            <div className="cco_content_area cco_content_area_0">
                <article className="react-container"  >
                    <div >
                        <NotificationBanner
                            background="red"
                            showBanner={photoBannerVisible}
                            message={PhotoBannerMessage}
                            color="white"
                            type="photo"
                            isMobile={isMobile}
                            isPhotoVisible={photoBannerVisible}
                            isCandidateVisible={candidateBannerVisible}
                            isPendingVisible={IsPendingCert}
                        />

                        {/* CANDIDATE ACCESS BANNER */}
                        <NotificationBanner
                            background={CandidateBannerColor}
                            showBanner={candidateBannerVisible}
                            message={CandidateBannerMessage}
                            color={Color}
                            type="ac"
                            isMobile={isMobile}
                            isPhotoVisible={photoBannerVisible}
                            isCandidateVisible={candidateBannerVisible}
                            isPendingVisible={IsPendingCert}
                        />

                        {/* PENDING CONNECTION BANNER */}
                        <NotificationBanner
                            background="yellow"
                            showBanner={IsPendingCert}
                            message={
                                <>
                                    {t("dashboard.pendingRequestBanner.part1")}{" "}
                                    <a
                                        href={`/account/organization-connections/${data.Id}`}
                                        style={{
                                            color: "black",
                                            textDecoration: "underline",
                                            fontWeight: 600,
                                        }}
                                        rel="noopener noreferrer"
                                    >
                                        {t("dashboard.pendingRequestBanner.click")}
                                    </a>{" "}
                                    {t("dashboard.pendingRequestBanner.part2")}    </>
                            }
                            color="black"
                            type="pending"
                            isMobile={isMobile}
                            isPhotoVisible={photoBannerVisible}
                            isCandidateVisible={candidateBannerVisible}
                            isPendingVisible={IsPendingCert}
                        />
                    </div>


                    <div className={(contact !== null && !error && data && !data.ContactPhotoRequest && !data.myCCOPicture) || (CandidateAccessControl && CandidateAccessControl !== 'Normal' && CandidateAccessControl !== 'Watched') ? 'cco_section bannerVisible' : 'cco_section cco_section_3'}>

                        {/* Show skeleton while loading, never block full screen */}
                        {loading ? (
                            <DashboardSkeleton />
                        ) : error ? (
                            <p>{error}</p>
                        ) : (
                            <>
                                {/* Intro div            */}
                                {CandidateAccessControl !== 'Locked' && (
                                    <>
                                        <div className="cco_row cco_row_4" style={{
                                            marginTop: getMarginTop()
                                        }}>
                                            <div className="cco_col">
                                                <div className="cco_text cco_text_0">
                                                    <div className="cco_text_inner">
                                                        <strong>{t('dashboard.hello', { name: data && data?.Name?.First })}</strong> {t('dashboard.welcomeUser')}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>



                                        {/* Profile Picture Card */}
                                        <div style={{
                                            marginTop: getMarginTop(),  // Dynamic margin based on banner visibility
                                        }} > <ProfileCard
                                                CandidateAccessControl={CandidateAccessControl}
                                            />

                                            {/* condition - profile is completed show below section                      */}

                                            {data.IsProfileCompleted && (
                                                <>
                                                {/* ── Action Cards Container with Border ── */}
                                                  <div className="cco_row cco_row_3 action-section-border">
                                                    {/* ── Three primary action cards ── */}
                                                    <div className="dash-cards-row">

                                                        {/* Submit Written Applications */}
                                                        <a
                                                            className={`dash-card${CandidateAccessControl === 'Suspended' ? ' btn-disabled' : ''}`}
                                                            onClick={handleIsExpiredClick}
                                                            href={token && customURLs?.onlineWrittenTestingUrl?.button_url && !isExpired && CandidateAccessControl !== 'Suspended'
                                                                ? customURLs.onlineWrittenTestingUrl.button_url + '?id_token=' + token
                                                                : '#'}
                                                            target={!isExpired && CandidateAccessControl !== 'Suspended' ? '_blank' : ''}
                                                            rel="noopener noreferrer"
                                                        >
                                                            <div className="dash-card-icon">
                                                                <img src="/Laptop.png" alt="Written App Logo" className="laptop-icon" />
                                                            </div>
                                                            <div className="dash-card-info">
                                                                <span className="dash-card-label">{t('dashboard.writingTestButton')}</span>
                                                            </div>
                                                            <div className="dash-card-overlay">
                                                                <p>{t('dashboard.writingTestHover')}</p>
                                                            </div>
                                                        </a>
                                                        
                                                        {/* Submit Practical Applications */}
                                                        <a
                                                            className={`dash-card${CandidateAccessControl === 'Suspended' ? ' btn-disabled' : ''}`}
                                                            onClick={handleIsExpiredClick}
                                                            href={token && customURLs?.practicalTestingUrl?.button_url && !isExpired && CandidateAccessControl !== 'Suspended'
                                                                ? customURLs.practicalTestingUrl.button_url + '?id_token=' + token
                                                                : '#'}
                                                            target={!isExpired && CandidateAccessControl !== 'Suspended' ? '_blank' : ''}
                                                            rel="noopener noreferrer"
                                                        >
                                                            <div className="dash-card-icon">
                                                                <img src="/equipment-operator-icon.png" alt="Practical App Logo" className="practical-icon" />
                                                            </div>
                                                            <div className="dash-card-info">
                                                                <span className="dash-card-label">{t('dashboard.practicalTestButton')}</span>
                                                            </div>
                                                            <div className="dash-card-overlay">
                                                                <p>{t('dashboard.practicalTestHover')}</p>
                                                            </div>
                                                        </a>

                                                        {/* Launch myCCO Exam Hub */}
                                                        <a
                                                            className={`dash-card${CandidateAccessControl === 'Suspended' ? ' btn-disabled' : ''}`}
                                                            href={token && REACT_APP_Exam_Hub_URL && CandidateAccessControl !== 'Suspended'
                                                                ? REACT_APP_Exam_Hub_URL + '?id_token=' + token
                                                                : '#'}
                                                            target={CandidateAccessControl !== 'Suspended' ? '_self' : ''}
                                                        >
                                                            <div className="dash-card-icon multi-icon">
                                                                <img src="/Calendar.png" alt="Exam Hub Logo" />
                                                                <img src="/Pass.png" alt="Exam Hub Logo" />
                                                                <img src="/Location.png" alt="Exam Hub Logo" />
                                                            </div>
                                                            <div className="dash-card-info">
                                                                <span className="dash-card-label">{t('dashboard.examHub.ExamHubButton')}</span>
                                                            </div>
                                                            <div className="dash-card-overlay">
                                                                <p style={{ whiteSpace: 'pre-line' }}>{t('dashboard.examHub.examHubHover')}</p>
                                                            </div>
                                                            
                                                        </a>
                                                    </div>

                                                    {/* ── Demo Exam button ── */}
                                                    <div className="dash-demo-container">
                                                        <a
                                                            className={`dash-demo-card ${CandidateAccessControl === 'Suspended' ? 'btn-disabled' : ''}`}
                                                            href={
                                                                CandidateAccessControl !== 'Suspended'
                                                                    ? localStorage.getItem('i18nextLng') === 'Spanish'
                                                                        ? 'https://portal.examstudio.com/?pl=opSLb5WtwZefXgn7buz9Mg%3d%3d'
                                                                        : environment.REACT_APP_DEMO_EXAM_URL
                                                                    : '#'
                                                            }
                                                            target={CandidateAccessControl !== 'Suspended' ? '_blank' : ''}
                                                            rel="noopener noreferrer"
                                                        >
                                                            <div className="demo-content">
                                                                <div className="demo-icon">
                                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                                        <path d="M8 5V19L19 12L8 5Z" />
                                                                    </svg>
                                                                </div>
                                                                <span>{t('dashboard.demoExamButton')}</span>
                                                            </div>
                                                            <div className="demo-action">
                                                               {t('dashboard.startDemo')}
                                                            </div>
                                                        </a>
                                                    </div>
                                                     
                                                     
                                                    </div>
                                                    <MyCertificationCard ProviderAccessControl={ProviderAccessControl} CCCOID={data?.SecondaryKeys?.[0]?.Key || ''} Name={data?.Name?.FullName || ''}
                                                        Profile={!data.myCCOPicture ? false : true}
                                                    />

                                                </>
                                            )}

                                        </div>
                                    </>
                                )}
                            </>
                        )}
                    </div>

                </article>

                <div className="cco_section cco_section_4">
                    <div className="cco_row">
                        <div className="cco_col">

                        </div>
                    </div>
                </div>

            </div>
        </div>

    );
};

